




















































import { Component, Prop, Watch, Model, Ref } from 'vue-property-decorator'
import { HsComponent } from '@hds/help-common/src/components/hs-components'

@Component({
  name: 'HsTimePicker',
})
/**
 * @vuese
 * @group component group
 * component description
 */
export default class extends HsComponent {
  @Model('value', { default: '00:00' }) value: string
  @Prop({ default: '시간설정' }) title: string
  @Prop({ default: false }) onlyHour: boolean
  @Prop({ default: false }) disabled: boolean
  @Prop({ default: 4 }) lineNum: number | string

  @Ref() hourWrap: HTMLElement
  @Ref() minWrap: HTMLElement

  // #region variables
  selectedTime: string = ''
  timeSpinnerPop = false
  hourLength: number = 24
  minLength: number = 60
  activeHourIndex: number = 0
  activeMinIndex: number = 0

  itemHeight: number = 48
  offsetHeight: number = 0

  wrapSize = {
    height: '',
  }

  rollStyle = {
    paddingTop: '',
    paddingBottom: '',
  }

  num2(num) {
    return Number(num) < 10 ? '0' + Number(num) : num.toString()
  }

  onClickHour(index) {
    this.activeHourIndex = index
    this.$vuetify.goTo(this.activeHourIndex * this.itemHeight, {
      container: this.hourWrap,
      duration: 300,
      easing: 'easeOutCubic',
      appOffset: false,
    })
  }

  onClickMin(index) {
    this.activeMinIndex = index
    this.$vuetify.goTo(this.activeMinIndex * this.itemHeight, {
      container: this.minWrap,
      duration: 300,
      easing: 'easeOutCubic',
      appOffset: false,
    })
  }

  toScroll() {
    this.$nextTick(function () {
      const scrollToHour = this.activeHourIndex * this.itemHeight
      const scrollToMin = this.activeMinIndex * this.itemHeight
      this.$vuetify.goTo(scrollToHour, {
        container: this.hourWrap,
        duration: 300,
        easing: 'easeOutCubic',
        appOffset: false,
      })
      this.$vuetify.goTo(scrollToMin, {
        container: this.minWrap,
        duration: 300,
        easing: 'easeOutCubic',
        appOffset: false,
      })
    })
  }

  scrollInit() {
    if (this.onlyHour) {
      if (this.value.length > 2 || Number(this.value) > this.hourLength - 1) {
        this.selectedTime = 'Error'
      } else {
        this.selectedTime = this.value
        this.activeHourIndex = Number(this.selectedTime)
        this.activeMinIndex = 0
      }
    } else if (this.value.length > 5 || this.value.charAt(2) !== ':') {
      this.selectedTime = 'Error'
    } else {
      this.selectedTime = this.value
      this.activeHourIndex = Number(this.selectedTime.split(':')[0])
      this.activeMinIndex = Number(this.selectedTime.split(':')[1])
    }
  }

  created() {
    this.wrapSize.height = Number(this.lineNum) * this.itemHeight + 'px'
    this.offsetHeight = (Number(this.lineNum) * this.itemHeight - this.itemHeight) / 2
    this.rollStyle = {
      paddingTop: this.offsetHeight + 'px',
      paddingBottom: this.offsetHeight + 'px',
    }

    this.scrollInit()
  }

  onClickInput() {
    this.timeSpinnerPop = true
    setTimeout(() => document.documentElement.classList.add('overflow-y-hidden'), 200)
    this.toScroll()
  }

  onClickConfirm() {
    this.timeSpinnerPop = false
    if (this.onlyHour) {
      this.selectedTime = this.num2(this.activeHourIndex)
    } else {
      this.selectedTime = this.num2(this.activeHourIndex) + ':' + this.num2(this.activeMinIndex)
    }
    this.$nextTick(function () {
      const modal = document.getElementsByClassName('v-dialog__content--active').length
      if (modal > 0) {
        setTimeout(() => document.documentElement.classList.add('overflow-y-hidden'), 200)
      } else {
        setTimeout(() => document.documentElement.classList.remove('overflow-y-hidden'), 200)
      }
    })
  }

  @Watch('value', { deep: true })
  onValueChanged(val: string) {
    this.selectedTime = val
  }

  @Watch('selectedTime', { deep: true })
  onSelectedTimeChanged(val: string) {
    this.$emit('value', val)
  }

  timeSpinnerPop
}
